import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "../lib/api";

const SiteCtx = createContext({ content: null, refresh: () => {} });

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  const refresh = useCallback(() => {
    api.get("/site").then((r) => setContent(r.data)).catch(() => setContent({}));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ content, refresh }), [content, refresh]);

  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
export const useSection = (key) => {
  const { content } = useContext(SiteCtx);
  return { data: content?.[key] || {}, loaded: content !== null };
};
